/**
 * @function getViewportWidth
 * @description Connaître la largeur de la fenêtre du navigateur
 *
 * @return {number}
 */

export const getViewportWidth = (): number => {

  // Checking the screen width
  let viewportWidth: number = typeof window.outerWidth === 'number' ? window.outerWidth : Number.NEGATIVE_INFINITY;

  // For iOs window.outerWidth returns 0
  if (viewportWidth === 0) {

    // If you're in a portrait
    if (typeof window.orientation !== 'undefined' && (window.orientation === 0 || window.orientation === 180)) {
        viewportWidth = screen.width;
    }
    else if (typeof window.orientation !== 'undefined' && (window.orientation === 90 || window.orientation === -90) && screen.availWidth > screen.width) {
      viewportWidth = screen.availWidth;
    }
    else {
      viewportWidth = $(window).width();
    }
  }

  return viewportWidth;
};
